import { render, staticRenderFns } from "./StudentPreviousObjectives.vue?vue&type=template&id=29cabfeb&scoped=true&lang=pug&"
import script from "./StudentPreviousObjectives.vue?vue&type=script&lang=ts&"
export * from "./StudentPreviousObjectives.vue?vue&type=script&lang=ts&"
import style0 from "./StudentPreviousObjectives.vue?vue&type=style&index=0&id=29cabfeb&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29cabfeb",
  null
  
)

export default component.exports